import { DataModel } from '../../dto/dto.js';
import { EventBookingStrategy } from './event-booking-strategy.js';

export abstract class EventBookingProtocol extends DataModel {
  abstract get strategy(): EventBookingStrategy;
}
